module.exports = __webpack_public_path__ + "img/delay_2.2d517a5f.svg";